import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import get from 'lodash/get'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'usuarioEstadoDefault',
    ...crudState()
  }),
  getters: {
    ...crudGetters
  },
  mutations: {
    ...crudMutations
  },
  actions: {
    ...crudActions,

    async checkConceptDefault({ dispatch }, { idusuario }) {
      // commit('setLoading', 1, { root: true });
      try {
        const response = await dispatch('custom', {
          method: 'get',
          endpoint: `usuario/estado/default-getby?idUsuario=${idusuario}`
        });
        
        return response;
      } catch (error) {
        // console.error("Error en checkConceptDefault:", error);
      } finally {
        // commit('setLoading', -1, { root: true });
      }
    }
  }
};
